import { useIntl } from "react-intl";

const SpaceAndPagePermissions = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.spaceAndPagePermissions.header",
            defaultMessage: "Space and page permissions"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.spaceAndPagePermissions.content",
            defaultMessage:
                "Assign, revoke, and modify space or page permissions to individual users, groups, or anonymous users. The Free plan doesn’t allow permission settings for spaces or pages."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.spaceAndPagePermissions.altText",
            defaultMessage: "Example of space settings"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.spaceAndPagePermissions.caption",
            defaultMessage:
                "Here’s what permission settings for a space look like in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/page-space-permissions.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default SpaceAndPagePermissions;
